import { Accordion, Stack, StackItem, Typography } from "@octopus-energy/coral/atoms"
import { useTranslations } from "next-intl"
import { CenteredImage } from "@/components/molecules"

const GAS_SERIAL_NUMBER_SRC = "/assets/images/illustrations/gas-serial-number.svg"

export function GasMeterSerialAccordion() {
    const t = useTranslations("GasMeterSerialAccordion")

    return (
        <Accordion
            theme="base500"
            headingLevel="h4"
            title={t("title")}
        >
            <Stack
                flexDirection="column"
                gap="lg"
            >
                <StackItem>
                    <Typography>
                        {t.rich("description", {
                            bold: (chunks) => <strong>{chunks}</strong>,
                        })}
                    </Typography>
                </StackItem>
                <StackItem>
                    <CenteredImage
                        src={GAS_SERIAL_NUMBER_SRC}
                        alt={t("imageAlt")}
                        height={150}
                        width={300}
                    />
                </StackItem>
            </Stack>
        </Accordion>
    )
}

GasMeterSerialAccordion.messages = ["GasMeterSerialAccordion"] as const
